export default "__VITE_ASSET__1f1e1912__"